import React from 'react'
import { User } from '../user'
import colors from '../../utils/colors'
import { CommentForm } from './comment-form'
import auth from '../../utils/auth'

const defaultPost = {
  title: 'Default Title'
}

const CommentSection = ({post = defaultPost, comments = [], ...props}) => {
  const { isOfficial } = auth()

  return (
    <div>
      <h3 className="lg:text-2xl mb-5 lg:mb-8 uppercase font-bold">
        { comments.length } comment on "{post.title}"
      </h3>
      <div>
        {
          comments.map((c, i) => (
            <div key={i}>
              <User name={c.user.name} className="mb-5"/>
              <p className="mb-4 text-sm text-gray-444">{c.date}</p>
              <p className="mb-4 lg:mb-5 text-sm text-gray-444">"{c.text}"</p>
              {
                isOfficial &&
                <div
                  className="rounded border text-primary text-xs text-center px-4 py-1 cursor-pointer inline-block"
                  style={{borderColor: colors.primary}}
                >
                  Reply
                </div>
              }
            </div>
          ))
        }
      </div>

      {
        isOfficial &&
        <div>
          <hr className="my-8" />

          <CommentForm />
        </div>
      }
    </div>
  )
}

export { CommentSection }